export function redirectToGoogle(
    productUid: string,
    accountName?: string,
    jobTitle?: string,
    hsCtaAttrib?: string
) {
    const baseUrl = `/account-registration/products/${productUid}/providers/google/login`;
    const params = new URLSearchParams();

    if (accountName) params.set("accountName", accountName);
    if (jobTitle) params.set("jobTitle", jobTitle);
    if (hsCtaAttrib) params.set("hsCtaAttrib", hsCtaAttrib);

    const query = params.toString();

    window.location.href = query ? `${baseUrl}?${query}` : baseUrl;
}
